import { render } from "./ButtonSuccess.vue?vue&type=template&id=2c051fde"
import script from "./ButtonSuccess.vue?vue&type=script&lang=js"
export * from "./ButtonSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__